import { render, staticRenderFns } from "./step_6.vue?vue&type=template&id=5a73e446&scoped=true&lang=pug&"
import script from "./step_6.vue?vue&type=script&lang=js&"
export * from "./step_6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a73e446",
  null
  
)

export default component.exports